<template>
  <div class="cp-set-languages main">
    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-language icon" />Languages</p>
      <div style="margin-left: 32px; margin-top: 10px">
        <p
          v-for="l in languages"
          :key="l"
          class="is-uppercase language"
          @click="preRemoveLanguage(l)"
        >
          <span class="icon">{{ l }}</span
          ><i class="fa fa-times-circle" style="color: #ccc" />
        </p>

        <div style="margin: 10px 0">
          <p
            v-if="showLanguageChoices"
            class="button is-light is-pulled-right"
            @click="showLanguageChoices = false"
          >
            <span>Cancel</span>
          </p>
          <p
            v-else
            class="button has-text-success"
            @click="showLanguageChoices = true"
          >
            <span>Add Language</span>
            <i class="fa fa-plus-circle" style="margin-left: 6px" />
          </p>
        </div>
        <div v-if="showLanguageChoices">
          <hr style="width: 52px; margin: 12px 0" />

          <p
            v-for="c in filteredLanguageChoices"
            :key="c"
            class="is-uppercase language"
            @click="addLanguage(c)"
          >
            <span class="icon">{{ c }}</span
            ><i class="fa fa-plus-circle has-text-success" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetLanguages",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      // updatingLanguages: false,
      showLanguageChoices: false,
      languageChoices: [
        "en",
        "th",
        "zh",
        "mm",
        "km",
        "ja",
        "fr",
        "es",
        "in", // indo
        "ms", // malay
        "vi",
        "tl", // tagalog
        "he", // hebrew
        "ar", // arabic
        "pt",
      ],
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    languages() {
      return this.commerce.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    filteredLanguageChoices() {
      return this.languageChoices.filter((c) => !this.languages.includes(c));
    },
  },
  methods: {
    addLanguage(c) {
      // this.infoToast("Add language: " + c);
      var langs = this.languages.concat(c);
      this.saveLanguages(langs);
    },
    preRemoveLanguage(remove) {
      this.$confirm({
        message: `Remove language ${remove.toUpperCase()}?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) this.removeLanguage(remove);
        },
      });
    },
    removeLanguage(remove) {
      var langs = this.languages.filter((l) => l !== remove);
      // this.infoToast(langs.join(", "));
      this.saveLanguages(langs);
    },
    saveLanguages(langs) {
      // this.updatingLanguages = true;
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: { languages: langs },
        })
        .then((res) => {
          this.successToast("Updated languages");
          this.commerce.data = res.data.data;
          this.showLanguageChoices = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide()); //(this.updatingLanguages = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.language {
  color: grey;
  padding: 5px 0;
}
.profile {
  margin-left: 32px;
  margin-top: 10px;
}
.profile img {
  display: inline-block;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  height: 90px;
  width: 90px;
}
.profile-pic-round {
  border-radius: 100px;
  object-fit: cover;
}
.profile-pic-square {
  border-radius: 2px;
  margin-right: 20px;
}
.banners img {
  object-fit: cover;
  height: 100px;
  width: 100%;
  margin-top: 10px;
}
</style>
